import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=b4dc22c4&scoped=true&"
import script from "./Col.vue?vue&type=script&lang=js&"
export * from "./Col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dc22c4",
  null
  
)

export default component.exports